//console.warn('oa-search-object.js loaded x1')
let searchData = {
  "complex_keywords":["veste jean","ba sh","pépé jeans","pepe jeans","pépéjeans"],
  "lexical": {
    "genres":{
      "homme":["homme", "hommes", "masculin", "garcon","garcons","garçon","garçons"],
      "femme":["femme", "femmes","féminin","feminin", "fille","filles","dame","dames"]
    },
    
    "categories":{
      "Chaussures":["chaussure","chaussures","shoes"],
      "Chemises et blouses":["Chemises et blouses","chemise","chemises"],
      "Combinaisons":["combinaison","combinaisons"],
      "Jeans":["jean","jeans"],
      "Jupes":["jupe","jupes","juppe","juppes"],
      "Pantalons et pantacourts":["pantalon","patalon","pantalons","pantacourt","pantacourts","pantacour","pantacours","patalons"],
      "Pulls et gilets":["pull","pulls","gilet","gilets","pull-over","sweat-shirt","chandail","tricot","col roulé"],
      "Robes":["robe","robes"],
      "Sacs":["sacs","sac"],
      "Shorts et bermudas":["shorts et bermudas","short","bermudas","shorts","bermuda"],
      "Tops et t-shirts":["tops et t-shirts","tops","top","t-shirts","t-shirt","t shirt","tshirt","tee","tee-shirt"],
      "Vestes et manteaux":["veste","blouson","blazer","caban","cardigan","coupe-vent","imperméable","parka","trench","doudoune"]
    },
    "subcategories":{
      "Baskets":["basket","baskets"],
      "Blazers et vestes costume":["blazer","costume"],
      "Blouses":["blouse","blouses"],
      "Bottes et Bottines":["bottes et bottines","bottes","bottines","botte","bottine"],
      "Chaussures plates":[],
      "Chemises":["chemise"],
      "Combi-pantalons":["combi","combinaison","combinaisons","combi-pantalons","combi-pantalon","combipantalon","salopette"],
      "Combi-shorts":["combi","combinaison","combinaisons","salopette"],
      "Débardeurs et Marcels":["débardeurs","marcels","debardeur","marcel"],
      "Escarpins":["escarpin","escarpins"],
      "Gilets":["gilets"],
      "Jeans bootcut":["bootcut"],
      "Jeans droit":[],
      "Jeans slim":["slim"],
      "Jupes courtes":["jupes courtes","jupe courte"],
      "Jupes longues":["jupe longue","jupes longues"],
      "Jupes mi longues":["jupes mi longues","jupes mi-longues","jupe mi-longue","jupe mi longue"],
      "Manteaux":[],
      "Pantalons":[],
      "Pantalons bootcut":["bootcut"],
      "Pantalons droit":[],
      "Pantalons slim":["slim"],
      "Pulls":[],
      "Polos":["polo","polos"],
      "Vestes":["veste","vestes","perfecto"],
      "Robes courtes":["robes courtes","robe courte"],
      "Robes longues":["robes longues","robe longue"],
      "Robes mi-longues":[],
      "Sweats":["sweats","sweat"],
      "T-shirts manches courtes":[],
      "T-shirts manches longues":[]  
    },
    "couleurs":{
      "noir":["noir","noire","noirs","noires","sombre", "sombres","foncé","foncés", "nuit"],
      "bleu":["bleu","bleus","bleue","bleues","bleu ciel"],
      "vert":["vert","verts","verte","vertes"],
      "blanc":["blanc","blancs","blanche","blanches"],
      "gris":["gris", "grise", "grisatre","grisâtre"],
      "beige":["beige","beiges","marron clair","marrons clair"],
      "jaune":["jaune","jaunes","or","citron","doré","ocre"],
      "orange":["orange","oranges"],
      "rouge":["rouge","rouges"],
      "rose":["rose","roses"],
      "violet":["violet","violets","violette","violettes","mauve","mauves"],
      "marron":["marron","marrons","café","chocolat"]
    },
    "tailles":{
      "32":["32","petit","petite taille"],
      "34 - T0 - XS":["34 - t0 - XS","34-T0-XS","34","XS","petit","petite taille"],
      "36 - T1 - S":["36 - t1 - S","36-T1-S","36","petit","petite taille"],
      "38 - T2 - M":["38 - t2 - M","38","M","m","T2"],
      "40 - T3 - L":["40 - T3 - L","40","t3","L"],
      "42 - T4 - L/XL":["42 - T4 - L/XL","42","t4","L/XL","L ou XL","L-XL"],
      "44 - T5 - XL/XXL":["44 - T5 - XL/XXL","44","T5","XL/XXL","XL ou XXL","XL-XXL"],
      "46 - T6 - XXL":["46 - T6 - XXL","46","t6", "XXL"],
      "48 - XXXL":["48 - XXXL","48","XXXL","48 XXXL"],
      "50 - XXXXL":["50 - XXXXL","50","xxxxl"],
      "52":["52","très grande taille"],
      "54":["54","plus grandes tailles"],
      "NA":["na"]
    },
    "pointures":{
    },
    "marques": {
      "adidas":["adidas"],
      "ba&sh":["ba sh"],
      "eric bompard":["bompard"],
      "zadig et voltaire":["zadig"],
      "balzac paris":["balzac"],
      "tommy hilfiger":["tommy"],
      "the north face":["north face", "nort face"],
      "sézane":["sezanne"]
    },
    "matiere":{
      "Acrylique":["acrylique","acrylic","acrilique","acrilic"],
      "Acétate":["acétate","acetate","acetates"],
      "Alpaga":["alpaga","alepaga"],
      "Angora":["angora","angoras","angorra","engora","angaura"],
      "Cachemire":["cashemir"],
      "Composition indisponible":["Composition indisponible","divers matière","divers matiere","divers matières"],
      "Coton":["coton"],
      "Cuir":["cuir"],
      "Cupro":["cupro"],
      "Laine":["laine"],
      "Lin":["lin"],
      "Lyocell":["lyocell"],
      "Modal":["modal"],
      "Mohair":["mohair","mohaire","moaire","mohère"],
      "Nylon":["nylon","nilon","nyllon"],
      "Polyamide":["polyamide"],
      "Polyester":["polyester"],
      "Rami":["rami"],
      "Rayon":["rayon"],
      "Soie":["soie"],
      "Tencel":["tencel","tencelle","tancel","tancelle"],
      "Viscose":["viscose"]
    },
    "reductions":{
      "20%":["20%","-20%","pas cher","reduction"],
      "35%":["35%","-35%","pas cher","reduction"],
      "50%":["50%","-35%","pas cher","reduction"],
    },
    "capsules":{
      "blue":["blue"],
      "crochet":["crochet"],
      "pastel":["pastel"],
      "rayures":["vêtements a rayures","rayure","rayures"],
      "Dentelle et broderie":["Dentelle et broderie","dentelle","broderie"],
      "Top motif":["tops motifs","top motif","tops a motifs"],
      "Vacances":["Vacances","vacance"],
      "veste en jean":["veste en jean","veste jean"],
      "Color block":["color block","colorblock"],
      "Grandes occasions":["grandes occasions"],
      "Bohème":["boheme"],
      "Festival":["festival"],
      "Sandales":["sandales"],
      "streetwear":["streetwear"],
      "Motif animal":["motif animal","motifs animal","motifs animaux"],
      "Tops à motifs":["Tops à motifs","Tops a motifs","Top motif"]
    },
    "divers":{
      "ancien":["ancien","usé"],
      "neuf":["neuf"]
    }
  }
}